import {
    STATISTICS_DASHBOARD_ROUTE,
    STATISTICS_DASHBOARD_SUCCESS
} from './constants';

/**
 *
 * @param Data
 * @returns {{Data: *, type}}
 */
const ststisticsDashBoard = (Data) => ({
  type: STATISTICS_DASHBOARD_ROUTE,
  Data
});

/**
 *
 * @param ststistics
 * @returns {{ststistics: *, type: string}}
 */
const ststisticsDashBoardSuccess = ststistics => ({
  type: STATISTICS_DASHBOARD_SUCCESS,
  ststistics
});

export {
    ststisticsDashBoard,
    ststisticsDashBoardSuccess
};
